import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Col, Row, InputGroup, Alert } from 'react-bootstrap';
import { useAuth } from '../common/AuthProvider';
import { useHistory, Link } from 'react-router-dom';
import { postData } from '../common/Api';
import { Eye, EyeSlash } from 'react-bootstrap-icons';

const SignUpForm = () => {

    const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
    });
    const { login, isAuthenticated } = useAuth();  
    const [error, setError] = useState('');
    const history = useHistory();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [changesDone, setChangesDone] = useState(false);

    useEffect(() => {
            if ( formData.password !== '' || formData.confirmPassword !== '') {
                setChangesDone(true);
            } else {
                setChangesDone(false);
            }
        }, [formData]);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
      if (error !== '' ){
        setError('');
      }
    };
  
    const handleSubmit =  async (e) => {
      e.preventDefault();

      const url = '/api/v1/sign-up';

      const payload = {
        'email': formData.email, 
        'password': formData.password, 
        'name': formData.name
      };

      // Check if passwords match
      if (formData.password !== formData.confirmPassword) {
        setError('Passwords do not match');
        return;
      }

      // Call the API to create a new user
      try {
        const response = await postData(url, payload);
        if (response.status === 201 || response.status === 200) {
          const loginResponse = await login(formData.email, formData.password);
          const success = loginResponse.result;
          if (!success) {
            var e = loginResponse.status === 401 ? 'Invalid email or password':
            loginResponse.status === 404 ? 'User not found': 'Login failed';
            setError(e);
          }
        } else {
          setError("Failed to login");
        }
        setError('');        
      } catch (error) {
        if (error.status === 409) {
          setError('User with this e-mail already exists');
        } else {
          setError(error.message);
        }
      }
    };

    useEffect(() => {
        if (isAuthenticated) {
          console.log('User is authenticated', window.location.pathname);
          history.push('/spaces');
        }
    }, [isAuthenticated]);
  
    return (
      <Container>
        <Row className="justify-content-md-center mt-5">
          <Col md={6}>
            <h2 className="text-center mb-4">Sign Up</h2>
  
            {/* Error Alert */}
            {error !== '' && <Alert variant="danger">{error}</Alert>}
  
            <Form onSubmit={handleSubmit}>
              {/* Name Field */}
              <Form.Group controlId="formName" className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  autoComplete="off"
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
  
              <Form.Group controlId="formEmail" className="mb-3">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <Form.Text className="text-muted">
                We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>

              {/* Password Field with Show/Hide Feature: can modify */}
              <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <InputGroup>
                        <Form.Control 
                            type={showPassword ? "text" : "password"}
                            name="password" 
                            placeholder="Enter your password"
                            value={formData.password} 
                            onChange={handleChange}
                            required
                        />
                        <Button 
                            variant="outline-secondary" 
                            onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <EyeSlash /> : <Eye />}
                        </Button>
                    </InputGroup>
                </Form.Group>

              {/* Confirm Password Field with Show/Hide Feature */}
              {formData.password !== '' && (
                    <Form.Group className="mb-3" controlId="formConfirmPassword">
                        <Form.Label>Confirm password</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Re-enter your password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                {showConfirmPassword ? <EyeSlash /> : <Eye />}
                            </Button>
                        </InputGroup>
                        <Form.Text className="text-muted">
                            {formData.password === formData.confirmPassword && formData.password !== '' 
                                ? "Passwords match" 
                                : "Passwords don't match"}
                        </Form.Text>
                    </Form.Group>
                )}
  
              {/* Submit Button */}
              <div className='flex-col-center w-100-perc'>
                <button className='btn-custom green w-100-perc' 
                      disabled={(formData.password !== formData.confirmPassword 
                        && formData.password !== '' 
                        || !changesDone)}>
                      Sign up </button>
              </div>

              <p style={{marginTop: '0.5rem'}}> Already have an account? <Link to="/login">Login</Link> instead. </p>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  };
  
  export default SignUpForm;